import { UPGRADES, AUTOMATION, SPEC_UPGRADES, MODULES, ABILITIES, COSMETICS, costFor } from "@cookies/shared/catalog/display"
import { escalateCostStr as sharedEscalateCostStr } from "@cookies/shared/economy"

export function displayNameFor(kind: string, id: string): string {
  if (kind === "module") return MODULES.find((m) => m.id === id)?.name ?? id
  if (kind === "ability") return ABILITIES.find((a) => a.id === id)?.name ?? id
  if (kind === "cosmetic" || kind === "equip") return COSMETICS.find((c) => c.id === id)?.name ?? id
  return upgradeDefFor(id)?.name ?? id
}

export function escalateCostStr(baseCostStr: string, steps: number): string {
  if (!Number.isFinite(steps) || steps <= 0) return baseCostStr
  return sharedEscalateCostStr(baseCostStr, steps)
}

export function upgradeDefFor(id: string) {
  return UPGRADES.find((d) => d.id === id) ?? AUTOMATION.find((d) => d.id === id) ?? SPEC_UPGRADES.find((d) => d.id === id)
}

export function projectPersonalFeeStr(cookieCost: string, personalCost?: string): string {
  if (personalCost !== undefined && personalCost !== "") return personalCost
  const c = BigInt(cookieCost)
  if (c <= 0n) return "1"
  const fee = c / 10n
  return (fee > 0n ? fee : 1n).toString()
}

export function nextUpgradeCostStr(id: string, nextLevel: number, chargedCost?: string): string {
  const def = upgradeDefFor(id)
  if (def) {
    try {
      return String(costFor(def, nextLevel))
    } catch {}
  }
  if (chargedCost !== undefined) return escalateCostStr(chargedCost, 1)
  return "0"
}
